import React from 'react';
import { observer } from 'mobx-react-lite';
import TableBase from 'common/components/table/table-base';
import { useLocation, useNavigate } from 'react-router-dom';
import eiqConnectStore from 'features/eiq-connect/store/eiq-connect.store';
import { AddressSelect } from 'features/eiq-connect/components/address-select/address-select';
import { SearchFilter } from 'common/components/table/filters/search-filter/search-filter';
import { FilterTypesEnum } from 'common/enums/filter-types.enum';
import { Button, Space } from 'antd';
import { ReactComponent as SearchIcon } from 'assets/icons/eiq-connect/search.svg';
import featureStore from 'common/stores/features/feature.store';
import { useMedia } from 'common/hooks/use-media/use-media.hook';
import { useTableContext } from 'common/components/table/table-context';
import TopHeader from '../../components/top-header/top-header';
import BottomHeader from '../../components/bottom-header/bottom-header';

export const AccessCardsList = observer(({ className }: any) => {
  const { isMobileOrTable } = useMedia();
  const navigate = useNavigate();
  const location = useLocation();
  const isMainPath = location.pathname.endsWith('/credentials');
  const isSearchPath = location.pathname.endsWith('/credentials/search');
  const tableContext = useTableContext();

  const selectFilter = (
    <SearchFilter
      enableProgressiveSearch={true}
      allowClear={true}
      placeholder="By facility code, device id"
      style={{ display: isSearchPath ? 'flex' : 'none' }}
      rulesForColumn={{
        facilityCode: FilterTypesEnum.Contains,
        deviceId: FilterTypesEnum.Contains,
      }}
    />
  );

  const addressSelect = (
    <AddressSelect
      value={eiqConnectStore.selectedAddressesId ? eiqConnectStore.selectedAddressesId : undefined}
      placeholder="Filter credentials by your addresses"
      className={isSearchPath ? 'display-none' : undefined}
      treeData={eiqConnectStore.addressOptions}
      onChange={(value) => eiqConnectStore.setSelectedAddressesId(value)}
    />
  );

  const getTitle = () => {
    if (featureStore.isCardAccessEnabled) {
      return (
        <span>
          <span onClick={() => navigate('/eiq-connect/vehicles')}>Vehicles</span>
          <span> | </span>
          <span className="active">Credentials</span>
        </span>
      );
    }
    return 'Credentials';
  };

  const actionButtons = (
    <Space size={10} className="eiq-action">
      <Button
        size="large"
        className="round-primary"
        onClick={() => {
          navigate('/eiq-connect/credentials/search');
        }}
        icon={<SearchIcon />}
      />
    </Space>
  );
  return (
    <div className={`eiq-guests-page ${className ?? ''}`}>
      <div className={`eiq-header ${isMainPath && 'main-page'}`}>
        <TopHeader>{!isSearchPath && actionButtons}</TopHeader>
        {isSearchPath ? <BottomHeader title="Search" /> : <h1 className="eiq-title title-tabs">{getTitle()}</h1>}

        {!isMobileOrTable && (
          <>
            {selectFilter}
            {addressSelect}
            {!isSearchPath && actionButtons}
          </>
        )}
      </div>
      <div className="eiq-content">
        {isMobileOrTable && selectFilter}

        {tableContext?.dataState?.data?.length > 0 && isSearchPath && <div className="eiq-search-result">Result</div>}

        {isMobileOrTable && addressSelect}

        <TableBase wrapperClass="eiq-table" headerHeight={0} fixed={false} rowHeight={116} />
      </div>
    </div>
  );
});
